import {
  RouteObject,
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom';

import DiagnosticsPage, {
  AuthDiagnostics,
  UserDiagnostics
} from '../pages/diagnostics';
import Report from '../pages/report';
import Reports from '../pages/reports';
import Dashboard from '../pages/dashboard';
import Mylibrary from '../pages/mylibrary';
import Protected from '../layouts/protected';
import InviteUser from '../pages/invite-user';
import { LibraryPage } from '../pages/library';
import { PageNotFound } from '../pages/errors';
import Diagnostics from '../layouts/diagnostics';
import { Permission } from '../types/permission';
import MyLibraryNew from '../pages/mylibrary-new';
import Feedback from '../pages/feedback/feedback';
import Users from '../pages/my-organisation/users';
import { designerRoutes } from './designer.routes';
import MyEvents from '../pages/my-events/my-events';
import UserPage from '../pages/my-organisation/user';
import GlobalLibrary from '../pages/global-libraries';
import { ZoneLibraries } from '../pages/zone-library';
import Assessment from '../pages/assessment/assessment';
import TiloWorldRecords from '../pages/tilo/world-records';
import { PrivacyPolicy, TermsOfUse } from '../pages/public';
import MyEventView from '../pages/my-events/my-events-view';
import { Authentication, Private, Public } from '../layouts';
import EventFormPage from '../pages/my-events/my-events-form';
import { administrationRoutes } from './administration.routes';
import FeedbackDetail from '../pages/feedback/feedback-detail';
import GlobalFeedback from '../pages/global-feedback/feedback';
import NetworkMembers from '../pages/my-network/network-members';
import FeedbackReadonly from '../pages/feedback/feedback-readonly';
import { GlobalZoneLibraries } from '../pages/zone-library/global';
import AssessmentDetail from '../pages/assessment/assessment-detail';
import GlobalAssessment from '../pages/global-assessment/assessment';
import { Facilitators } from '../pages/my-organisation/facilitators';
import MyOrganisation from '../pages/my-organisation/my-organisation';
import AssessmentReadonly from '../pages/assessment/assessment-readonly';
import { AuthRequired } from '../components/authentication/auth-required';
import GlobalFeedbackDetail from '../pages/global-feedback/feedback-detail';
import { AssessmentMonacoPage } from '../pages/assessment/assessment-monaco';
import NetworkOrganisations from '../pages/my-network/network-organisations';
import { GlobalAssessmentDetail } from '../pages/global-assessment/assessment-detail';

export const appRoutes: RouteObject[] = [
  {
    element: <Public />,
    children: [
      { path: '/privacy-policy', element: <PrivacyPolicy /> },
      { path: '/terms-of-use', element: <TermsOfUse /> }
    ]
  },
  {
    path: '/',
    element: <Private />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'dashboard/', element: <Dashboard /> },

      {
        path: 'myorganisation/',
        element: <Protected allowedRoles={[Permission['Organisation.Info']]} />,
        children: [{ index: true, element: <MyOrganisation /> }]
      },

      {
        path: 'users/',
        element: (
          <Protected
            allowedRoles={[
              Permission['OrgAdmin.Members'],
              Permission['Organisation.ViewMembers']
            ]}
          />
        ),
        children: [
          { index: true, element: <Users /> },
          { path: ':id', element: <UserPage /> },
          { path: 'invite-user/', element: <InviteUser /> },
          { path: 'new', element: <UserPage /> }
        ]
      },

      {
        path: 'facilitators/',
        children: [
          { index: true, element: <Facilitators /> },
          {
            element: (
              <Protected
                allowedRoles={[Permission['OrgAdmin.ManageFacilitators']]}
              />
            ),
            children: [
              { path: ':id', element: <UserPage /> },
              { path: 'invite-facilitator/', element: <InviteUser /> }
            ]
          }
        ]
      },

      {
        path: 'networkorganisations/',
        element: (
          <Protected allowedRoles={[Permission['Network.Organisations']]} />
        ),
        children: [{ index: true, element: <NetworkOrganisations /> }]
      },

      {
        path: 'networkmembers/',
        element: <Protected allowedRoles={[Permission['Network.Members']]} />,
        children: [{ index: true, element: <NetworkMembers /> }]
      },

      {
        path: 'myevents/',
        element: <Protected allowedRoles={[Permission.Events]} />,
        children: [
          { index: true, element: <MyEvents /> },
          { path: 'new', element: <EventFormPage /> },
          { path: 'edit/:id', element: <EventFormPage /> }
        ]
      },

      {
        path: 'myeventview/:id',
        element: <Protected allowedRoles={[Permission.Events]} />,
        children: [{ index: true, element: <MyEventView /> }]
      },

      {
        path: 'mylibrary/games/',
        element: <Protected allowedRoles={[Permission['MyLibrary.Games']]} />,
        children: [
          { index: true, element: <Mylibrary /> },
          { path: 'new', element: <MyLibraryNew /> }
        ]
      },

      {
        path: 'mylibrary/zones/',
        element: <Protected allowedRoles={[Permission['MyLibrary.Zones']]} />,
        children: [{ index: true, element: <ZoneLibraries /> }]
      },

      {
        path: 'mylibrary/assessment/',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Assessments']]} />
        ),
        children: [
          { index: true, element: <Assessment /> },
          { path: 'new', element: <AssessmentDetail /> }
        ]
      },

      {
        path: 'assessment-details/:id',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Assessments']]} />
        ),
        children: [
          { index: true, element: <AssessmentDetail /> },
          { path: 'monaco', element: <AssessmentMonacoPage /> }
        ]
      },

      {
        path: 'assessment-detail-view/:id',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Assessments']]} />
        ),
        children: [{ index: true, element: <AssessmentReadonly /> }]
      },

      {
        path: 'mylibrary/feedback/',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Feedback']]} />
        ),
        children: [
          { index: true, element: <Feedback /> },
          { path: 'new', element: <FeedbackDetail /> }
        ]
      },

      {
        path: 'feedback-details/:id',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Feedback']]} />
        ),
        children: [{ index: true, element: <FeedbackDetail /> }]
      },

      {
        path: 'feedback-detail-readonly/:id',
        element: (
          <Protected allowedRoles={[Permission['MyLibrary.Feedback']]} />
        ),
        children: [{ index: true, element: <FeedbackReadonly /> }]
      },

      {
        path: 'global-games/',
        element: (
          <Protected allowedRoles={[Permission['GlobalLibrary.Games']]} />
        ),
        children: [
          { index: true, element: <GlobalLibrary /> },
          { path: ':id', element: <LibraryPage /> }
        ]
      },

      {
        path: 'global-zones/',
        element: (
          <Protected allowedRoles={[Permission['GlobalLibrary.Zones']]} />
        ),
        children: [{ index: true, element: <GlobalZoneLibraries /> }]
      },

      {
        path: 'global-assessment/',
        element: (
          <Protected allowedRoles={[Permission['GlobalLibrary.Assessments']]} />
        ),
        children: [
          { index: true, element: <GlobalAssessment /> },
          { path: 'new', element: <GlobalAssessmentDetail /> }
        ]
      },

      {
        path: 'global-assessment-details/:id',
        element: (
          <Protected allowedRoles={[Permission['GlobalLibrary.Assessments']]} />
        ),
        children: [{ index: true, element: <GlobalAssessmentDetail /> }]
      },

      {
        path: 'global-feedback/',
        element: (
          <Protected allowedRoles={[Permission['GlobalLibrary.Feedback']]} />
        ),
        children: [
          { index: true, element: <GlobalFeedback /> },
          { path: 'new', element: <GlobalFeedbackDetail /> }
        ]
      },

      {
        path: 'global-feedback-details/:id',
        element: <Protected allowedRoles={[Permission.Events]} />,
        children: [{ index: true, element: <GlobalFeedbackDetail /> }]
      },

      {
        path: 'reports/',
        element: <Protected allowedRoles={[Permission.Reports]} />,
        children: [
          { index: true, element: <Reports /> },
          { path: ':eventId/:detailId/:type', element: <Report /> }
        ]
      }
    ]
  },

  {
    path: '/diagnostics',
    element: <Diagnostics />,
    children: [
      { index: true, element: <DiagnosticsPage /> },
      { path: 'user', element: <UserDiagnostics /> },
      { path: 'auth', element: <AuthDiagnostics /> }
    ]
  },

  {
    path: '/tilo/world-records',
    element: (
      <AuthRequired>
        <TiloWorldRecords />
      </AuthRequired>
    )
  },

  {
    element: <Authentication />,
    children: [{ path: '*', element: <PageNotFound /> }]
  }
];

const router = createBrowserRouter([
  ...appRoutes,
  designerRoutes,
  administrationRoutes
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
